import { Component, Inject, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '@app/services/login.service';
import { environment } from 'environments/environment';
import { empty } from 'rxjs';
import { error, log } from 'console';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  ambiente = 'Desenvolvimento';
  login = '';
  senha = '';
  producao: boolean;

  loginVazio: boolean = false;
  senhaVazia: boolean = false;
  carregando: boolean;

  constructor(private router: Router,
    private loginService: LoginService,
    @Inject(ToastrService) public toastr: ToastrService
  ) {
    if (environment.PRODUCAO) {
      this.producao = true;
    }
  }

  ngOnInit() {
    if (environment.PRODUCAO) {
      this.ambiente = 'Produção';
    }
  }

  onSubmit() {
    this.carregando = true;

    if(!this.validaCampos()){
      this.carregando = false;
      return;
    }
    localStorage.removeItem('Cardeal.Token');

    this.loginService.login(this.login, this.senha).subscribe(
      (data: any) => {

        if (data.DescricaoErro && data.DescricaoErro.length > 0) {
          this.carregando = false;
          this.toastr.error(data.DescricaoErro);
          return;
        }

        const possuiAutenticacaoHabilitada = data.PossuiAutenticacaoDoisFatores ?? false;
        localStorage.setItem('Autenticacao.Habilitada', JSON.stringify(possuiAutenticacaoHabilitada));

        if (possuiAutenticacaoHabilitada === true) {
          this.router.navigate(['/autenticacao-dois-fatores']);

          localStorage.setItem('Cardeal.Login', this.login);
          localStorage.setItem('Cardeal.Senha', this.senha);
        }

        else {
          localStorage.setItem('Cardeal.Token', data.AccessToken);
          localStorage.setItem('Cardeal.Usuario', JSON.stringify(data.NomeUsuario));
          localStorage.setItem('Login.Rapido', '0');

          this.router.navigate(['/dashboard']);
          this.toastr.success('Carregando...');

          localStorage.setItem('Cardeal.Login', this.login);
          localStorage.setItem('Cardeal.Senha', this.senha);
        }
      },
      (error) => {
        this.carregando = false;
        this.toastr.error(typeof (error._body) === typeof ('') ? error._body : '', 'Login Inválido');
      })
    }

  validaCampos() {
    if(!this.login || !this.senha){
      this.loginVazio = !this.login;
      this.senhaVazia = !this.senha;
      return false;
    }

    this.loginVazio = false;
    this.senhaVazia = false;
    return true;
  }
}
